import Axios from 'axios'
import React, { useEffect, useState } from 'react'
import LiveFixturesByDate from './LiveFixturesByDate'

function AllLeaguesLive({ allFixtures, date }) {
    const [leagues, setLeagues] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const [show, setShow] = useState(false)
    const [searchTerm, setSearchTerm] = useState('')

    // Too slow, need to limit number of leagues
    useEffect(() => {
        async function fetchLeagues() {
            try {
                const response = await Axios({
                    method: 'GET',
                    url: 'https://api-football-v1.p.rapidapi.com/v2/leagues/season/2020',
                    headers: {
                        'x-rapidapi-key':
                            '4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45',
                        'x-rapidapi-host': 'api-football-v1.p.rapidapi.com',
                    },
                })
                const data = response.data.api.leagues
                setLeagues(data)
            } catch (error) {}
        }
        fetchLeagues()
    }, [date])

    useEffect(() => {
        if (searchTerm && leagues.length) {
            console.log(searchTerm)
        }
    }, [searchTerm, leagues])

    function filterFixturesLeague(allFixturesDate, leagueId) {
        const leagueFixtures = allFixturesDate.filter((league) => {
            return +league.league_id === +leagueId
        })
        return leagueFixtures
    }

    function toggle() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    return (
        <div>
            <div
                className="card card-header"
                style={{ cursor: 'pointer' }}
                onClick={toggle}
            >
                <div>
                    Vis alle turneringer{' '}
                    <span className="float-right">
                        <i
                            className={`fas fa-chevron-${show ? 'down' : 'up'}`}
                        ></i>
                    </span>
                </div>
            </div>

            {show && (
                <React.Fragment>
                    {leagues?.map((league, index) => {
                        const leagueFixtures = filterFixturesLeague(
                            allFixtures,
                            league.league_id
                        )

                        return (
                            <LiveFixturesByDate
                                key={index}
                                leagueId={league.league_id}
                                leagueLogo={league.logo}
                                leagueName={league.name}
                                leagueFixtures={leagueFixtures}
                                isLoading={isLoading}
                                setIsLoading={setIsLoading}
                            />
                        )
                    })}
                </React.Fragment>
            )}
        </div>
    )
}
export default AllLeaguesLive
